/**修改默认密码 */
export class UpdateDefaultPasswordVO {
  constructor() {
    this.password = "";
    this.rePassword = "";
  }
}
/**修改密码 */
export class UpdatePasswordVO extends UpdateDefaultPasswordVO {
  constructor() {
    super();
    this.oldPassword = "";
  }
}
